import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";
import { useSendLogoutMutation } from "../features/auth/authApiSlice";
import useAuth from "../hooks/useAuth";
import useTitle from "../hooks/useTitle";
import DashHeader from "./DashHeader";
import DashFooter from "./DashFooter";

import { Fragment, useState, useEffect } from "react";
import {
  Dialog,
  DialogPanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import {
  Bars3Icon,
  ChartPieIcon,
  Cog6ToothIcon,
  HomeIcon,
  UsersIcon,
  XMarkIcon,
  CalculatorIcon,
  BriefcaseIcon,
  CircleStackIcon,
} from "@heroicons/react/24/outline";
import { ChevronDownIcon, ChevronLeftIcon } from "@heroicons/react/20/solid";

const DashLayout = () => {
  // const { email, roles, status, isKlijent, isAdmin, id, jmbg } = useAuth();

  // console.log(email, roles, status, isKlijent, isAdmin, id, jmbg);

  // const [sendLogout, { isLoading, isSuccess, isError, error }] =
  //   useSendLogoutMutation();

  // const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  // const navigation = [
  //   { name: "Product", href: "#" },
  //   { name: "Features", href: "#" },
  //   { name: "Resources", href: "#" },
  //   { name: "Company", href: "#" },
  // ];

  return (
    <>
      <DashHeader />
      <div className="m-3">
        <Outlet />
      </div>
      <DashFooter />
    </>
  );
};
export default DashLayout;

// <div>
//             <Transition show={sidebarOpen}>
//             <Dialog className="relative z-50 lg:hidden" onClose={setSidebarOpen}>
//                 <TransitionChild enter="transition-opacity ease-linear duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-opacity ease-linear duration-300" leaveFrom="opacity-100" leaveTo="opacity-0">
//                     <div className="fixed inset-0 bg-gray-900/80" />
//                 </TransitionChild>

//                 <div className="fixed inset-0 flex">
//                 <TransitionChild enter="transition ease-in-out duration-300 transform" enterFrom="-translate-x-full" enterTo="translate-x-0" leave="transition ease-in-out duration-300 transform" leaveFrom="translate-x-0" leaveTo="-translate-x-full">
//                     <DialogPanel className="relative mr-16 flex w-full max-w-xs flex-1">
//                     <TransitionChild enter="ease-in-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in-out duration-300" leaveFrom="opacity-100" leaveTo="opacity-0">
//                         <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
//                         <button type="button" className="-m-2.5 p-2.5" onClick={() => setSidebarOpen(false)}>
//                             <span className="sr-only">Close sidebar</span>
//                             <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
//                         </button>
//                         </div>
//                     </TransitionChild>
//                     {/*  */}
//                     <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-blue-600 px-6 pb-4">
//                         <div className="flex h-16 shrink-0 items-center">
//                         <img
//                             className="h-8 w-auto"
//                             src="https://tailwindui.com/img/logos/mark.svg?color=white"
//                             alt="Your Company"
//                         />
//                         </div>
//                         <nav className="flex flex-1 flex-col">
//                         <ul role="list" className="flex flex-1 flex-col gap-y-7">
//                             <li>
//                                 <ul role="list" className="-mx-2 space-y-1">
//                                     {/* Mobile nav */}
//                                     <li key="Dashboard">
//                                         <a onClick={() => { handleLinkClick('Dashboard'); vidiDash(); setSidebarOpen(false); }} style={{ cursor: "pointer" }} className={`text-blue-200 hover:text-white hover:bg-blue-800 group flex gap-x-3 rounded p-2 text-sm leading-6 font-semibold ${activeIndex === 'Dashboard' ? 'bg-blue-700 text-white' : ''}`}>
//                                         <HomeIcon className={classNames('text-white', 'h-6 w-6 shrink-0')} aria-hidden="true"/>Dashboard</a>
//                                     </li>

//                                     {
//                                         roles[0] === "Editor" ?
//                                             <>
//                                                 <li key="Analitika">
//                                                     <a onClick={() => { handleLinkClick('Analitika'); vidiAnalytics(); setSidebarOpen(false); }} style={{ cursor: "pointer" }} className={`text-blue-200 hover:text-white hover:bg-blue-800 group flex gap-x-3 rounded p-2 text-sm leading-6 font-semibold ${activeIndex === 'Analitika' ? 'bg-blue-700 text-white' : ''}`}>
//                                                     <ChartPieIcon className={classNames('text-white', 'h-6 w-6 shrink-0')} aria-hidden="true"/>Analitika</a>
//                                                 </li>

//                                                 <li key="Obracuni">
//                                                     <a onClick={() => { handleLinkClick('Obracuni'); vidiObracune(); setSidebarOpen(false); }} style={{ cursor: "pointer" }} className={`text-blue-200 hover:text-white hover:bg-blue-800 group flex gap-x-3 rounded p-2 text-sm leading-6 font-semibold ${activeIndex === 'Obracuni' ? 'bg-blue-700 text-white' : ''}`}>
//                                                     <CalculatorIcon className={classNames('text-white', 'h-6 w-6 shrink-0')} aria-hidden="true"/>Obračuni</a>
//                                                 </li>

//                                                 <li key="Zaposleni">
//                                                     <a onClick={() => { handleLinkClick('Zaposleni'); userLista(); setSidebarOpen(false); }} style={{ cursor: "pointer" }} className={`text-blue-200 hover:text-white hover:bg-blue-800 group flex gap-x-3 rounded p-2 text-sm leading-6 font-semibold ${activeIndex === 'Zaposleni' ? 'bg-blue-700 text-white' : ''}`}>
//                                                     <UsersIcon className={classNames('text-white', 'h-6 w-6 shrink-0')} aria-hidden="true"/>Zaposleni</a>
//                                                 </li>

//                                                 <li key="Organizacije">
//                                                     <a onClick={() => { handleLinkClick('Organizacije'); vidiOrganicaciju(); setSidebarOpen(false); }} style={{ cursor: "pointer" }} className={`text-blue-200 hover:text-white hover:bg-blue-800 group flex gap-x-3 rounded p-2 text-sm leading-6 font-semibold ${activeIndex === 'Organizacije' ? 'bg-blue-700 text-white' : ''}`}>
//                                                     <BriefcaseIcon className={classNames('text-white', 'h-6 w-6 shrink-0')} aria-hidden="true"/>Organizacije</a>
//                                                 </li>
//                                             </>
//                                         : ""
//                                     }

//                                 </ul>
//                             </li>

//                             <li className="mt-auto">
//                                 <a onClick={() => { handleLinkClick('Settings'); vidiProjects(); setSidebarOpen(false); }} style={{ cursor: "pointer" }} className={`text-blue-200 hover:text-white hover:bg-blue-800 group flex gap-x-3 rounded p-2 text-sm leading-6 font-semibold ${activeIndex === 'Settings' ? 'bg-blue-700 text-white' : ''}`}>
//                                     <Cog6ToothIcon className={classNames('text-white', 'h-6 w-6 shrink-0')} aria-hidden="true"/>Settings
//                                 </a>
//                             </li>

//                         </ul>
//                         </nav>
//                     </div>
//                     </DialogPanel>
//                 </TransitionChild>
//                 </div>
//             </Dialog>
//             </Transition>

//             {/* Desktop */}
//             <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-52 lg:flex-col">
//             <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-blue-600 px-6 pb-4">
//                 <div className="flex h-16 shrink-0 items-center">
//                 {/* Navbar logo */}
//                 <img className="h-8 w-full h-full mt-5 mr-2" src={`${process.env.PUBLIC_URL}/img/logo.png`} alt="Your Company"/>
//                 </div>
//                 <nav className="flex flex-1 flex-col">
//                 <ul role="list" className="flex flex-1 flex-col gap-y-7">
//                     <li>
//                         <ul role="list" className="-mx-2 space-y-1">
//                             {/* Desktop nav */}
//                             <li key="Dashboard">
//                                 <a onClick={() => { handleLinkClick('Dashboard'); vidiDash(); unToggleExpansion(); }} style={{ cursor: "pointer" }} className={`text-blue-200 hover:text-white hover:bg-blue-800 group flex gap-x-3 rounded p-2 text-sm leading-6 font-semibold ${activeIndex === 'Dashboard' ? 'bg-blue-700 text-white' : ''}`}>
//                                 <HomeIcon className={classNames('text-white', 'h-6 w-6 shrink-0')} aria-hidden="true"/>Dashboard</a>
//                             </li>

//                             {
//                                 roles[0] === "Editor" ?
//                                     <>
//                                         <li key="Analitika">
//                                             <a onClick={() => { handleLinkClick('Analitika'); vidiAnalytics(); unToggleExpansion(); }} style={{ cursor: "pointer" }} className={`text-blue-200 hover:text-white hover:bg-blue-800 group flex gap-x-3 rounded p-2 text-sm leading-6 font-semibold ${activeIndex === 'Analitika' ? 'bg-blue-700 text-white' : ''}`}>
//                                             <ChartPieIcon className={classNames('text-white', 'h-6 w-6 shrink-0')} aria-hidden="true"/>Analitika</a>
//                                         </li>

//                                         <li key="Obracuni">
//                                             <a onClick={() => { handleLinkClick('Obracuni'); vidiObracune(); unToggleExpansion(); }} style={{ cursor: "pointer" }} className={`text-blue-200 hover:text-white hover:bg-blue-800 group flex gap-x-3 rounded p-2 text-sm leading-6 font-semibold ${activeIndex === 'Obracuni' ? 'bg-blue-700 text-white' : ''}`}>
//                                             <CalculatorIcon className={classNames('text-white', 'h-6 w-6 shrink-0')} aria-hidden="true"/>Obračuni</a>
//                                         </li>

//                                         <li key="Organizacije">
//                                             <a onClick={() => { handleLinkClick('Organizacije'); vidiOrganicaciju(); unToggleExpansion(); }} style={{ cursor: "pointer" }} className={`text-blue-200 hover:text-white hover:bg-blue-800 group flex gap-x-3 rounded p-2 text-sm leading-6 font-semibold ${activeIndex === 'Organizacije' ? 'bg-blue-700 text-white' : ''}`}>
//                                             <BriefcaseIcon className={classNames('text-white', 'h-6 w-6 shrink-0')} aria-hidden="true"/>Organizacije</a>
//                                         </li>

//                                         <li key="Zaposleni">
//                                             <a onClick={() => { handleLinkClick('Zaposleni'); userLista(); unToggleExpansion(); }} style={{ cursor: "pointer" }} className={`text-blue-200 hover:text-white hover:bg-blue-800 group flex gap-x-3 rounded p-2 text-sm leading-6 font-semibold ${activeIndex === 'Zaposleni' ? 'bg-blue-700 text-white' : ''}`}>
//                                             <UsersIcon className={classNames('text-white', 'h-6 w-6 shrink-0')} aria-hidden="true"/>Zaposleni</a>
//                                         </li>

//                                         {/* ARROW */}
//                                         <li key="Podaci">
//                                             <div onClick={() => { handleLinkClick('Podaci'); toggleExpansion(); }} style={{ cursor: "pointer" }} className={`text-blue-200 hover:text-white hover:bg-blue-800 group flex gap-x-3 rounded p-2 text-sm leading-6 font-semibold ${activeIndex === 'Podaci' ? 'bg-blue-700 text-white' : ''}`}>
//                                                 <CircleStackIcon className='text-white h-6 w-6 shrink-0' aria-hidden="true" />
//                                                 <span className="flex-1">Podaci</span>
//                                                     {isExpanded ? (
//                                                         <ChevronDownIcon className="h-5 w-5 text-white" aria-hidden="true" />
//                                                     ) : (
//                                                         <ChevronLeftIcon className="h-5 w-5 text-white" aria-hidden="true" />
//                                                     )}
//                                             </div>

//                                             {isExpanded && (
//                                                 <ul className="pl-8 mt-2">
//                                                     <li onClick={() => { handleLinkClick('Tip organizacije'); vidiTipOrg(); }} style={{ cursor: "pointer", fontSize: "12px" }} className={`relative text-blue-200 hover:text-white hover:bg-blue-800 group flex gap-x-3 rounded p-2 pl-8 text-sm leading-6 font-semibold ${activeIndex === 'Tip organizacije' ? 'bg-blue-700 text-white before:content-["➔"] before:absolute before:left-2 before:opacity-100' : 'before:content-["➔"] before:absolute before:left-2 before:opacity-0 hover:before:opacity-100'}`}>
//                                                         Tip organizacije
//                                                     </li>

//                                                     <li onClick={() => { handleLinkClick('Pozicije'); vidiPozicije(); }} style={{ cursor: "pointer", fontSize: "12px" }}  className={`relative text-blue-200 hover:text-white hover:bg-blue-800 group flex gap-x-3 rounded p-2 pl-8 text-sm leading-6 font-semibold ${activeIndex === 'Pozicije' ? 'bg-blue-700 text-white before:content-["➔"] before:absolute before:left-2 before:opacity-100' : 'before:content-["➔"] before:absolute before:left-2 before:opacity-0 hover:before:opacity-100'}`}>
//                                                         Pozicije
//                                                     </li>

//                                                     <li onClick={() => { handleLinkClick('Sektor'); vidiSektor(); }} style={{ cursor: "pointer", fontSize: "12px" }}  className={`relative text-blue-200 hover:text-white hover:bg-blue-800 group flex gap-x-3 rounded p-2 pl-8 text-sm leading-6 font-semibold ${activeIndex === 'Sektor' ? 'bg-blue-700 text-white before:content-["➔"] before:absolute before:left-2 before:opacity-100' : 'before:content-["➔"] before:absolute before:left-2 before:opacity-0 hover:before:opacity-100'}`}>
//                                                         Sektor
//                                                     </li>

//                                                     <li onClick={() => { handleLinkClick('Tipovi ugovora'); vidiUgovori(); }} style={{ cursor: "pointer", fontSize: "12px" }}  className={`relative text-blue-200 hover:text-white hover:bg-blue-800 group flex gap-x-3 rounded p-2 pl-8 text-sm leading-6 font-semibold ${activeIndex === 'Tipovi ugovora' ? 'bg-blue-700 text-white before:content-["➔"] before:absolute before:left-2 before:opacity-100' : 'before:content-["➔"] before:absolute before:left-2 before:opacity-0 hover:before:opacity-100'}`}>
//                                                         Tipovi ugovora
//                                                     </li>

//                                                 </ul>
//                                             )}

//                                         </li>
//                                     </>
//                                 : ""
//                             }

//                         </ul>
//                     </li>

//                     <li className="mt-auto">
//                         <a onClick={() => { handleLinkClick('Settings'); vidiProjects(); }} style={{ cursor: "pointer" }} className={`text-blue-200 hover:text-white hover:bg-blue-800 group flex gap-x-3 rounded p-2 text-sm leading-6 font-semibold ${activeIndex === 'Settings' ? 'bg-blue-700 text-white' : ''}`}>
//                             <Cog6ToothIcon className={classNames('text-white', 'h-6 w-6 shrink-0')} aria-hidden="true"/>Settings
//                         </a>
//                     </li>

//                 </ul>
//                 </nav>
//             </div>
//             </div>

//             {/* Padding content container on right */}
//             <div className="lg:pl-52">
//             <div className="sticky top-0 z-40 flex h-10 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
//                 <button type="button" className="-m-2.5 p-2.5 text-gray-700 lg:hidden" onClick={() => setSidebarOpen(true)}>
//                 <span className="sr-only">Open sidebar</span>
//                 <Bars3Icon className="h-6 w-6" aria-hidden="true" />
//                 </button>

//                 {/* Separator */}
//                 <div className="h-6 w-px bg-gray-900/10 lg:hidden" aria-hidden="true" />

//                 <div className="flex flex-1 justify-end gap-x-4 self-stretch lg:gap-x-6">
//                 {/* <form className="relative flex flex-1" action="#" method="GET">
//                     <label htmlFor="search-field" className="sr-only">
//                     Search
//                     </label>
//                     <MagnifyingGlassIcon
//                     className="pointer-events-none absolute inset-y-0 left-0 h-full w-5 text-gray-400"
//                     aria-hidden="true"
//                     />
//                     <input
//                     id="search-field"
//                     className="block h-full w-full border-0 py-0 pl-8 pr-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm"
//                     placeholder="Search..."
//                     type="search"
//                     name="search"
//                     />
//                 </form> */}
//                 <div className="flex items-center gap-x-4 lg:gap-x-6">
//                     {/* <button type="button" className="-m-2.5 p-2.5 text-gray-400 hover:text-gray-500">
//                     <span className="sr-only">View notifications</span>
//                     <BellIcon className="h-6 w-6" aria-hidden="true" />
//                     </button> */}

//                     {/* Separator */}
//                     <div className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-900/10" aria-hidden="true" />

//                     {/* Profile dropdown */}
//                     <Menu as="div" className="relative">
//                     <MenuButton className="-m-1.5 flex items-center p-1.5">
//                         <span className="sr-only">Open user menu</span>
//                         <img className="h-8 w-8 rounded-full bg-gray-50" src={`${process.env.PUBLIC_URL}/img/profil.jpg`} alt="Profil slika"/>
//                         <span className="hidden lg:flex lg:items-center">
//                         <span className="ml-4 text-sm font-semibold leading-6 text-gray-900" aria-hidden="true">
//                             {/* {username === 'Admin' ? username : username - status}  */}
//                             {username}
//                         </span>
//                         <ChevronDownIcon className="ml-2 h-5 w-5 text-gray-400" aria-hidden="true" />
//                         </span>
//                     </MenuButton>
//                     <Transition enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
//                         {/* Nav user options */}
//                         <MenuItems className="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
//                             {/* VIDE SAMO ODREDJENI */}
//                             {/* {isAdmin || isManager ?
//                                 <MenuItem className='block px-3 py-1 text-sm leading-6 text-gray-900' onClick={()=>console.log("Tvoj profil")}>
//                                     <a onClick={vidiProfil} className={'block px-3 py-1 text-sm leading-6 text-gray-900'} style={{cursor: "pointer"}}>Tvoj profil</a>
//                                 </MenuItem> :
//                                 ""
//                             } */}
//                             {/* ZA SAD SVI VIDE SVOJ PROFIL, NE ZABORAVI DA PROEMNIS PERMISIJE U APP.JS */}

//                             {/* {
//                                 roles[0] === "Editor" ?
//                                     <MenuItem className='block px-3 py-1 text-sm leading-6 text-gray-900' onClick={()=>console.log("Tvoj profil")}>
//                                         <a onClick={vidiProfil} className={'block px-3 py-1 text-sm leading-6 text-gray-900'} style={{cursor: "pointer"}}>Tvoj profil</a>
//                                     </MenuItem>
//                                 : ""
//                             } */}

//                             <MenuItem className='block px-3 py-1 text-sm leading-6 text-gray-900'>
//                                 <a onClick={sendLogout} className={'block px-3 py-1 text-sm leading-6 text-gray-900'} style={{cursor: "pointer"}}>Izloguj se</a>
//                             </MenuItem>

//                         </MenuItems>
//                     </Transition>
//                     </Menu>
//                 </div>
//                 </div>
//             </div>

//                 <main className="py-3">
//                     <div className="px-3 sm:px-3 lg:px-3">
//                         {/* Content template */}
//                         <Outlet />
//                     </div>
//                 </main>

//             </div>
//         </div>
